export const METADATA_STATUSES = [
  'Draft',
  'Approved',
  'Published',
  'Rejected',
  'Archived',
] as const;

export type MetadataStatus = (typeof METADATA_STATUSES)[number];

export const METADATA_STATUS_TRANSITIONS: Record<
  MetadataStatus,
  MetadataStatus[]
> = {
  Draft: ['Approved', 'Rejected', 'Archived'],
  Approved: ['Draft', 'Published', 'Archived', 'Rejected'],
  Published: ['Draft', 'Rejected', 'Archived'],
  Rejected: ['Draft', 'Archived'],
  Archived: ['Draft'],
};

export interface IMetadataStatusVisual {
  iconName: string;
  color: string;
}

export const METADATA_STATUS_VISUALS: Record<
  MetadataStatus,
  IMetadataStatusVisual
> = {
  Draft: { iconName: 'Edit', color: '#605e5c' },
  Approved: { iconName: 'StatusCircleCheckmark', color: '#107c10' },
  Published: { iconName: 'CloudUpload', color: '#0078d4' },
  Rejected: { iconName: 'Blocked', color: '#a4262c' },
  Archived: { iconName: 'Archive', color: '#605e5c' },
};
